import { createActionGroup, props } from '@ngrx/store';
import { DocMetaResponse } from '@qtek/shared/models';

export const TermSheetActions = createActionGroup({
  source: 'Term Sheet',
  events: {
    'Subscribe Doc Meta': props<{
      mysid: string;
      q: any[];
    }>(),
    'Get Doc Meta Success': props<{ mysid: string; res: DocMetaResponse }>(),
    'Get Doc Meta Failure': props<{ error: any }>(),
    'Unsubscribe Doc Meta': props<{ mysid: string }>(),
  },
});
